<template>
  <div style="display: flex; width: 100%; gap: 10px; align-items: center;">
    <div style="display: flex; gap: 10px; width: 100%;" :style="getIsMobile() ? { gap: '3px', overflowX: 'auto', flexDirection: 'column' } : {}">
      <div style="display: flex; gap: 10px; align-items: center;" :style="getIsMobile() ? { width: '100%', justifyContent: 'space-between' } : {}">
        <input
          id="startFilter"
          type="date"
          v-model="Statistics_StartDate"
          :max="Statistics_EndDate"
          style="width: 230px;"
          :style="getIsMobile() ? { fontSize: '11px', width: '160px' } : {}"
        />
        ~
        <input
          id="endFilter"
          type="date"
          v-model="Statistics_EndDate"
          :min="Statistics_StartDate"
          :max="ConvertDateTimeString(nowDate, 'YYYY-MM-DDTHH:MM')"
          style="width: 230px;"
          :style="getIsMobile() ? { fontSize: '11px', width: '160px' } : {}"
        />
      </div>
      <div class="button-group" style="width: 110px; height: 39px">
        <button type="button" @click.stop="updateChartData()" class="action-button" :style="getIsMobile() ? {height: '39px', padding: '0', fontSize: '10px'} : {}">{{ $t('search') }}</button>
      </div>
    </div>
    <div class="button-group" v-show="!getIsMobile()">
      <button class="white-button" @click="exportToExcel(deviceList, Statistics_StartDate, Statistics_EndDate)" style="display: flex; gap: 5px;">
        {{ $t('excel_download') }}
        <img src="@/assets/images/download_blue.svg"/>
      </button>
    </div>
  </div>
  
  <!-- #region 출입 통계 -->
  <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; height: calc(100% - 380px); padding-top: 10px;">
    <canvas ref="entryexitChartCanvas" style="width: 100%; height: 300px; border-radius: 20px; border: 1px solid #D9D9D9;" :style="getIsMobile() ? { height: '370px', maxHeight: '370px' } : { height: '300px', maxHeight: '300px' }"></canvas>
  </div>
  <!-- #endregion -->

   <!-- 테이블 + 페이지네이션 -->
  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
    <table style="height: 290px; max-height: 290px; overflow-y: unset; padding: 0;">
      <thead>
        <tr>
          <th class="w40p" style="cursor: default;">
            {{ $t('geofence') }}
          </th>
          <th class="w30p" style="cursor: default;">
            {{ $t('enter_count') }}
          </th>
          <th class="w30p" style="cursor: default;">
            {{ $t('exit_count') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="([date, data, index]) in paginatedData" :key="date">
          <td :title="data.geofenceName" class="w40p" @click.stop="" style="cursor: default;">
            {{ data.geofenceName }}
          </td>
          <td :title="data.enterCount" class="w30p" @click.stop="showChartTooltip(index)" style="cursor: default;">
            {{ data.enterCount }}
          </td>
          <td :title="data.exitCount" class="w30p" @click.stop="" style="cursor: default;">
            {{ data.exitCount }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pagination-control" style="">
      <div>
        <img src="@/assets/images/double_arrow_left_gray.svg" @click.stop="prevPagePer" v-show="currentPage !== 1"/>
        <img src="@/assets/images/arrow_left_gray.svg" @click.stop="prevPage" v-show="currentPage !== 1"/>
      </div>
      <span v-for="page in currentPageRange" :key="page" @click.stop="currentPage = page" :class="{ selected: currentPage === page }" :style="currentPage === page ? {cursor: 'default'} : {}">{{ page }}</span>
      <div>
        <img src="@/assets/images/arrow_right_gray.svg" @click.stop="nextPage" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
          <img src="@/assets/images/double_arrow_right_gray.svg" @click.stop="nextPagePer" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue';
import i18n from '@/i18n';
import { Chart, registerables } from "chart.js";
import { GET_SERVER_REQUEST } from '@/utils/ServerConnect';
import { ConvertDateTimeString, getIsMobile } from '@/utils/GlobalUtility';
import { currentDate, datetimeRange, nowDate, Statistics_EndDate, Statistics_StartDate } from '@/utils/StatisticsUtility';
import { loadingStore } from '@/utils/LoadingStore';

Chart.register(...registerables);
const tableData = ref(null);
const chartInstance = ref(null);
const event_list = ref([]);
const geofence_list = ref([]);

// 구역별 출입 횟수
const entryexitChartCanvas = ref(null);
const entryexitCountMap = ref(new Map());
const entryexitCountMapArray = ref(null);
const entryexitChartData = ref({
  labels: [],
  datasets: [
    {
      label: i18n.global.t('enter_count'),
      data: [],
      borderColor: 'green',
      borderWidth: 2,
      pointBorderColor: '#FFF', // 데이터 포인트 테두리 색상
      pointBackgroundColor: 'green', // 데이터 포인트 색상
      pointRadius: 5, // 데이터 포인트 크기
    },
    {
      label: i18n.global.t('exit_count'),
      data: [],
      borderColor: 'orange',
      borderWidth: 2,
      pointBorderColor: '#FFF', // 데이터 포인트 테두리 색상
      pointBackgroundColor: 'orange', // 데이터 포인트 색상
      pointRadius: 5, // 데이터 포인트 크기
    },
  ],
});
const entryexitChartOptions = ref({
  responsive: true,
  plugins: {
    title: {
      display: true,  // 제목을 표시할지 여부
      text: '사용자 현황',  // 제목 내용
      font: {
        size: getIsMobile() ? 14 : 18,  // 제목 폰트 크기
        weight: 'bold',  // 제목 폰트 굵기
      },
      color: '#333',  // 제목 색상
    },
    legend: {
      display: true, // 범례 표시 여부
      labels: {
        generateLabels: () => {
          return []; // <- 아예 레전드 데이터 자체를 빈배열로 만들어서 완전 제거
        }
      },
    },
  },
  scales: {
    x: {
      title: {
        display: true,  // X축 제목을 표시할지 여부
        // text: i18n.global.t('date'),  // X축 제목
        font: {
          size: getIsMobile() ? 12 : 16,  // X축 제목 폰트 크기
        },
        color: '#000',  // X축 제목 색상
      },
      // offset: true, // X축 중앙 정렬 효과
    },
    y: {
      title: {
        display: true,  // Y축 제목을 표시할지 여부
        // text: i18n.global.t('count'),  // Y축 제목
        font: {
          size: getIsMobile() ? 12 : 16,  // Y축 제목 폰트 크기
        },
        color: '#000',  // Y축 제목 색상
      },
      beginAtZero: true,  // Y축 0부터 시작
    },
  },
});
const setEntryExit = async () => {
  event_list.value = await GET_SERVER_REQUEST("event", datetimeRange.value);
  geofence_list.value = await GET_SERVER_REQUEST("geofence");

  const newEntryExitMap = new Map();

  event_list.value.forEach(event => {
    const { geofence_id, action } = event;

    if (!newEntryExitMap.has(geofence_id)) {
      const geofence = geofence_list.value.find(g => g.geofence_id === geofence_id);
      const geofenceName = geofence ? geofence.geofence_name : `Unknown (${geofence_id})`;

      newEntryExitMap.set(geofence_id, {
        enterCount: 0,
        exitCount: 0,
        geofenceName: geofenceName
      });
    }

    const currentCounts = newEntryExitMap.get(geofence_id);
    if (action === 'enter') {
      currentCounts.enterCount++;
    } else if (action === 'exit') {
      currentCounts.exitCount++;
    }
  });

  entryexitCountMap.value = newEntryExitMap;

  entryexitCountMapArray.value = Array.from(entryexitCountMap.value.entries()).map((item, index) => {
    // item은 [date, data] 형태의 배열입니다.
    // 여기에 index를 추가하여 [date, data, index] 형태로 만듭니다.
    return [...item, index];
  });
  
  const labels = [];
  const enterData = [];
  const exitData = [];
  newEntryExitMap.forEach(data => {
    labels.push(data.geofenceName);
    enterData.push(data.enterCount);
    exitData.push(data.exitCount);
  });
  entryexitChartData.value.labels = labels;
  entryexitChartData.value.datasets[0].data = enterData;
  entryexitChartData.value.datasets[1].data = exitData;

  // 데이터가 1개일 경우 중앙에 배치
  if (entryexitChartData.value.labels.length === 1) {
    entryexitChartData.value.labels.unshift('')
    entryexitChartData.value.labels.push('')
    entryexitChartData.value.datasets.forEach(dataset => {
      dataset.data.unshift(null)
      dataset.data.push(null)
    })
  }

  tableData.value = entryexitCountMapArray.value;
};

// 차트 데이터 갱신
const updateChartData = async () => {
  loadingStore.showLoading();
  
  event_list.value = await GET_SERVER_REQUEST("event", datetimeRange.value);

  await setEntryExit();

  if (chartInstance.value) {
    chartInstance.value.destroy();
  }

  if (entryexitChartCanvas.value) {
    const ctx = entryexitChartCanvas.value.getContext('2d');
    chartInstance.value = new Chart(ctx, {
      type: 'line',
      data: entryexitChartData.value,
      options: entryexitChartOptions.value,
    });
  }

  loadingStore.hideLoading();
};

onMounted(async () => {
  await nextTick(async () => {
    const today = new Date().toISOString().split('T')[0];  // YYYY-MM-DD 형식으로 현재 날짜 가져오기
    currentDate.value = Statistics_StartDate.value = Statistics_EndDate.value = today;
    
    await updateChartData();
  });
});

onUnmounted(() => {
  if (chartInstance.value) {
    chartInstance.value.destroy();
  }
});

const showChartTooltip = (index) => {
  const activeElements = [
    {
      datasetIndex: 0, // 첫 번째 데이터셋 (Daily Accesses)
      index: index      // 클릭된 테이블 행의 인덱스
    }
    // 필요하다면 다른 데이터셋의 동일한 인덱스 포인트도 추가할 수 있습니다.
    // , { datasetIndex: 1, index: index }
  ];

  // console.log(chartInstance.value[2].tooltip.setActiveElements(activeElements, { x: 0, y: 0 }))
  console.log(chartInstance.value[2])
  console.log(activeElements);
}

//#region 페이지네이션
const currentPage = ref(1);
const itemsPerPage = ref(5);
const showOncePage = computed(() => { return (getIsMobile() ? 5 : 10) });
// 페이지네이션된 데이터 계산
const totalPages = computed(() =>
  Math.ceil(tableData.value?.length / itemsPerPage.value)
);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  return tableData.value?.slice(start, start + itemsPerPage.value);
});
const minPageRange = computed(() => {
  if (currentPage.value % showOncePage.value === 0) return currentPage.value - (showOncePage.value - 1);
  else return currentPage.value - ((currentPage.value % showOncePage.value) - 1);
});
const maxPageRange = computed(() => {
  let num = minPageRange.value + (showOncePage.value - 1);
  if (num > totalPages.value) num = totalPages.value
  return num;
});
const currentPageRange = computed(() => {
  const range = []
  for (let i = minPageRange.value; i <= maxPageRange.value; i++) {
    range.push(i)
  }
  return range;
});
// 페이지네이션 함수
const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--;
};
const prevPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  if (num < 1) currentPage.value = 1;
  else currentPage.value = ((num - 1) * showOncePage.value) + 1;
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++;
};
const nextPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  const check = ((num + 1) * showOncePage.value) + 1
  if (check > totalPages.value) currentPage.value = totalPages.value;
  else currentPage.value = check;
};
//#endregion
</script>